import axios from "axios"
import { memo } from "react"

// for deve
// const baseURL = "http://localhost:1545/api/"

// for  live host ui
const baseURL = "https://live.asktek.net/global_office_manage_website_api/api/"

// test api
// const baseURL = "http://targettest.asktek.net/target.ankita.adminpanel.webapi/api"

const instance = axios.create({
  baseURL,
})

export default {
  instance,
  baseURL,
}

// please note while run build if you face any heap memory issue then try below code for build
// node --max-old-space-size=4096 ./node_modules/react-scripts/bin/react-scripts.js build
